import styled from 'styled-components';

import { Paper } from '@components/Paper';

export const Container = styled(Paper)`
  margin: 24px;
  padding: 20px 24px;
`;

export const TableContainer = styled.div`
  .multiplicity-row > td {
    background-color: #fff7e6;
  }

  .multiplicity-row:hover > td {
    background-color: #ffe7ba !important;
  }
`;
